/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";

import { getDraftProviderOptions } from "api/services/draftRequest";
import { GetDraftProviderOptionsResponseType } from "api/response/draftRequest.response";
import { useCustomQuery } from "hooks/useCustomQuery";
import { draftRequestQueryKeys } from "./draftRequestQueryKeys";

type GetDraftProviderOptions = {
  draftId: string;
  freightModes: string;
  form?: "v1" | "v2";
  options?: UseQueryOptions<GetDraftProviderOptionsResponseType>;
};

export const useGetDraftProviderOptions = (data: GetDraftProviderOptions) =>
  useCustomQuery<GetDraftProviderOptionsResponseType>({
    queryKey: draftRequestQueryKeys.draftProviderOptionsListing(data.draftId, data.freightModes, data.form),
    queryFn: () =>
      getDraftProviderOptions(data.draftId, {
        params: {
          freight_modes: data.freightModes,
          ...(data.form ? { form: data.form } : {}),
        },
      }).then((res) => res.data),
    ...data.options,
  });
